module.exports = "<h1 class=\"mat-h1\" i18n>Активные сделки</h1>\n\n<user-deals-list [allowedList]=\"allowedStatuses\"></user-deals-list>\n"